import { render, staticRenderFns } from "./UPrintResults.vue?vue&type=template&id=3a4974b6&"
import script from "./UPrintResults.vue?vue&type=script&lang=js&"
export * from "./UPrintResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports